//
// Tooltip Functionality
//
module.exports = (function() {
    var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
    var $window = $(window);
    var Events = require('common/events');
    var timeout;
    var delay = 250;

    var checkSidePlacement = function($anchor) {

        if ( ! $anchor ) {
            $anchor = $(this);
        }

        var $parent = $anchor.parent();
        var anchorOffset = $anchor.offset();
        var windowWidth = $window.width();
        var anchorWidth = $anchor.width();
        var scrollLeft = $window.scrollLeft();
        var tooltipOffsetLeft = anchorOffset.left - scrollLeft + anchorWidth;

        var $tooltip = $anchor.siblings('.tooltip__tooltip');
        var tooltipWidth = $tooltip.width();

        var tooltipOffsetRight = windowWidth - tooltipOffsetLeft - tooltipWidth;

        if ( tooltipOffsetRight < 0 ) {
            $parent.addClass('tooltip--flipped');
        } else {
            $parent.removeClass('tooltip--flipped');
        }
    };

    var checkAllSidePlacements = function() {
        $('a.tooltip').each(checkSidePlacement);
    };

    var mouseleave = function(event) {
        clearTimeout(timeout);

        Events.cancel(event);
        Events.stopPropagation(event);

        var $this = $(this);

        if ( $this.is('.tooltip__container') ) {
            $this.removeClass('tooltip--hovered');
        } else {
            $this.closest('.tooltip__container').removeClass('tooltip--hovered');
        }
    };

    var hovered = function() {
        $(this).addClass('tooltip--hovered');
    };

    var hover = function(event) {
        timeout = setTimeout(hovered.bind(this), delay);
    };

    var clickOpen = function(event) {
        Events.cancel(event);
        Events.stopPropagation(event);

        clearTimeout(timeout);

        // open or close it if it's open
        if (! $(this).hasClass('tooltip--clicked')) {
            $(this).addClass('tooltip--clicked');
            $('html').addClass('tooltip-clicked');
        } else {
            $(this).removeClass('tooltip--clicked tooltip--hovered');
            $('html').removeClass('tooltip-clicked');
        }
    };

    var clickClosed = function(event) {
        Events.cancel(event);
        Events.stopPropagation(event);

        clearTimeout(timeout);

        var $this = $(this);

        if ( $this.is('.tooltip__container') ) {
            $this.removeClass('tooltip--clicked tooltip--hovered');
            $('html').removeClass('tooltip-clicked');
        } else {
            $this.closest('.tooltip__container').removeClass('tooltip--clicked tooltip--hovered');
            $('html').removeClass('tooltip-clicked');
        }
    };

    var createTooltip = function() {
        var $anchor     = $(this).addClass('tooltip__anchor').removeAttr('title');
        var $container  = $( document.createElement('div') ).addClass('tooltip__container')
            .on('mouseenter', hover)
            .on('mouseleave', mouseleave)
            .on('click', clickOpen);

        $anchor.wrap($container);

        var $tooltip = $(document.createElement('div')).addClass('tooltip__tooltip').insertAfter($anchor);
        var $inner = $( document.createElement('div') ).addClass('tooltip__inner').appendTo($tooltip);

        var $title      = $(document.createElement('h6')).text($anchor.attr('data-tooltip-title')).appendTo($inner);
        var $content    = $(document.createElement('p')).html($anchor.attr('data-tooltip-content').replace(/(?:\r\n|\r|\n)/g, '<br />')).appendTo($inner);
        var $close      = $(document.createElement('a')).addClass('tooltip__close').appendTo($inner);

        Events.onElementRendered($tooltip, checkSidePlacement);

        $close.on('click', clickClosed);
    };

    var init = function() {
        $('a.tooltip').each(createTooltip);

        $window.on('load', checkAllSidePlacements);
        $window.on('resize', Events.cling('checkTooltipPlacements', checkAllSidePlacements));
    };

    return {
        init: init
    };
})();
